import React from "react";

interface IProps {
  type: "next" | "prev";
  onClick: () => void;
}

export const ControlButton: React.FC<IProps> = ({
  type,
  onClick
}) => {

  function handleOnClikc() {
    onClick();
  }

  return (
    <>
      <button className={`carousel-control-${type}`} style={{ "background": "transparent", "border": "none" }} onClick={handleOnClikc}>
        <span className={`carousel-control-${type}-icon`}></span>
        <span className={"sr-only"}>
          {type === "next" && "Próximo"}
          {type === "prev" && "Anterior"}
        </span>
      </button>
    </>
  );
}